
//Global Varibles
var navbarWindow = $(window),
    allowWindowScroll = true,

//desktop variables
    isScrolling = false,
    bgAnimationInterval = null,
    colorAnimationInterval = null,
    navOpacity = 0,
    navColor = 255,
    navCompleteAnimationClass = "solid-bg",
    navSlidingMenuClass = "sliding-menu",

//mobile variables
    mobileFixDisplayedClass = "bottom-displayed",
    mobileInquireDisplayedClass = "mb-inquire-diplayed",
    mobileInquireHiddenClass = "mb-inquire-hidden",
    mobileInquireNavClass = "mb-inquire-nav",
    mobileNavOverlayId = "#sidenav-overlay";



/* ========== DESKTOP FUNCTIONS =========== */

/**
 * @summary Stop all animations and resets all intervals related to them.
 */
var animateStop = function (){
    if (typeof bgAnimationInterval !== 'undefined' || bgAnimationInterval !== null) {
        clearInterval(bgAnimationInterval);
        bgAnimationInterval = null;
    }

    if (typeof colorAnimationInterval !== 'undefined' || colorAnimationInterval !== null) {
        clearInterval(colorAnimationInterval);
        colorAnimationInterval = null;
    }
}

/**
 * @summary Animates the transition on background color for an element. This avoids the use of Jquery UI.
 * @param element The DOM element.
 * @param milisecs The animation duration.
 * @param inverse The direction for the animation, to transparent or to white.
 * @param callback The callback function to be ran after all animations are completed.
 */
var animateBackground = function(element, milisecs, inverse, callback) {

    var multiplier = 4,
        totalSteps = 100,
        increment = (inverse ? -0.01 : 0.01) * multiplier,
        repeatInterval = milisecs / (totalSteps / multiplier),
        currentStep = Math.floor(navOpacity * 100),
        count = inverse ? totalSteps - currentStep : currentStep;

    bgAnimationInterval = setInterval(updateBGColor, repeatInterval)

    function updateBGColor() {
        if (count >= totalSteps) {
            animateStop();
            callback();
        } else {
            count = count + multiplier;
            navOpacity = navOpacity + increment;
            element.css("background-color", "rgba(255, 255, 255, " + navOpacity + ")");
            element.css("-webkit-box-shadow", "0px 0px 20px 0px rgba(0, 0, 0, " + navOpacity / 2 + ")");
            element.css("-moz-box-shadow", "0px 0px 20px 0px rgba(0, 0, 0, " + navOpacity / 2 + ")");
            element.css("box-shadow", "0px 0px 20px 0px rgba(0, 0, 0, " + navOpacity / 2 + ")");
        }
    }
}

/**
 * @summary Animates the transition for color text on element. This avoids the use of Jquery UI.
 * @param element The DOM element.
 * @param milisecs The animation duration.
 * @param inverse The direction for the animation, to white or to gray.
 * @param callback The callback function to be ran after all animations are completed.
 */
var animateTextColor = function(element, milisecs, inverse, callback) {

    var multiplier = 4,
        totalSteps = 170,
        increment = (inverse ? 1 : -1) * multiplier,
        repeatInterval = milisecs / (totalSteps / multiplier),
        currentStep = 255 - navColor,
        count = inverse ? totalSteps - currentStep : currentStep;

    colorAnimationInterval = setInterval(updateTextColor, repeatInterval)

    function updateTextColor() {
        if (count >= totalSteps) {
            animateStop();
            callback();
        } else {
            count = count + multiplier;
            navColor = Math.floor(navColor + increment);
            element.find("a").not(".dropdown-content li a").css("color", "rgb(" + navColor + ", " + navColor + ", " + navColor + ")");
        }
    }
}

/* ========== MOBILE FUNCTIONS =========== */

/**
 * @summary Determines if the mobile sticky element and the mobile inquire button should be displayed based on the current screen position and context.
 * @param stickyNav The DOM element for the mobile sticky.
 * @param inquireBtn The DOM element for the inquire now link.
 */
var checkMobileFixedStatus = function(stickyNav, inquireBtn){
    var viewTop = navbarWindow.scrollTop();
    if(viewTop >= 200){
        if(!stickyNav.hasClass(mobileFixDisplayedClass)){
            stickyNav.addClass(mobileFixDisplayedClass);//.stop().animate({ bottom:'0px' }, 200);
        }
        if(!inquireBtn.hasClass(mobileInquireHiddenClass)){
            inquireBtn.removeClass(mobileInquireNavClass);
            inquireBtn.addClass(mobileInquireDisplayedClass).stop().animate({ bottom:'0px' }, 250);
        }
        else{
            inquireBtn.removeClass(mobileInquireDisplayedClass).stop().animate({ bottom:'-100px' }, 250, function(){
                inquireBtn.removeClass(mobileInquireNavClass);
            });
        }
    }
    else if(viewTop < 200 && stickyNav.hasClass(mobileFixDisplayedClass)){
        stickyNav.removeClass(mobileFixDisplayedClass);//.stop().animate({ bottom:'-100px' }, 200);
        inquireBtn.removeClass(mobileInquireDisplayedClass).stop().animate({ bottom:'-100px' }, 250, function(){
            inquireBtn.removeClass(mobileInquireNavClass);
        });
    }
}

/**
 * @summary Adds or removes "active" class on an element with a toggle behavior.
 * @param element The DOM element.
 */
var toggleActiveClass = function(element, className){
    if(element.hasClass(className)){
        element.removeClass(className);
    } else {
        element.addClass(className);
    }
}

$(document).ready(function(){

    //Destktop Nav Elements
    var desktopBrandLogo = $(".logo-color"),
        desktopNav = $("#main-nav"),
        desktopTopNav = $(".nav-top-line"),
        desktopTopNavItems = $(".nav-top-items"),
        //desktopNavElements = $(".desktop-nav-menu"),
        //desktopNavElementsOriginalWidth = 0,
        //search elements
        desktopNavSearchBtn = $(".desktop-nav-search"),
        desktopNavSearchContainer = $(".nav-search-box"),
        desktopSearchInput = $("#search-text-desktop"),
        desktopSearchIcon = $(".desktop-search-icon"),
        desktopSearchGoBackIcon = $(".desktop-search-back-icon"),
        //desktop currency
        desktopCurrency = $(".desktop-currency"),
        desktopCurrencySelector = $(".desktop-currency-selector"),
        desktopCurrencyList = desktopCurrency.find("ul"),
        //desktop dropdown menu
        desktopDropDown = $(".dropdown-button");

    //Mobile Nav Elements
    var mobileStickyNav = $(".mobile-fixed"),
        mobileNavBtn = $(".button-collapse"),
        mobileNavToggle = $(".mobile-nav-toggle"),
          //mobileNavAction = $(".mobile-nav-action"),
        mobileStickyOpenIcon = $(".fixed-open-nav"),
        mobileStickyCloseIcon = $(".fixed-close-nav"),
        //search elements
        mobileSearchInput = $("#search-text"),
        mobileSearchBtn = $(".mobile-nav-search"),
        mobileSearchInputBtn = $(".mobile-search-input-btn"),
        mobileSearchIcon = $(".mobile-search-icon"),
        //inquire elements
        mobileInquireNow = $(".mobile-inquire-btn"),
        mobileInquireHideBtn = $(".inquire-close"),
        mobileInquireShowBtn = $(".show-inquire"),
        mobileInquireForm = $(".mobile-inquire-form"),
        mobileInquireFormClose = mobileInquireForm.find(".close-form"),
        //currency elements
        mobileCurrencySelector = $(".mobile-currency-selector"),
        mobileCurrencyArrow = mobileCurrencySelector.find(".material-icons"),
        mobileCurrencyOptions = $(".currency-nav"),
        //share elements
        mobileShareToggle = $(".show-share"),
        mobileShareTooltip = $("#share-icons");

    /* ========== MOBILE EVENTS =========== */

    mobileNavBtn.sideNav({
        onOpen: function(){
            //mobileNavAction.fadeOut(100);
            mobileStickyOpenIcon.fadeOut(100, function() {
                mobileStickyCloseIcon.fadeIn(100);
            });
            mobileStickyNav.addClass(mobileFixDisplayedClass);//.stop().animate({ bottom:'0px' }, 200);
            mobileInquireNow.addClass(mobileInquireNavClass);
            mobileInquireNow.addClass(mobileInquireDisplayedClass).stop().animate({ bottom:'0px' }, 250);
        },
        onClose: function(){
            //mobileNavAction.fadeIn(100);
            checkMobileFixedStatus(mobileStickyNav, mobileInquireNow);
            mobileStickyCloseIcon.fadeOut(100, function() {
                mobileStickyOpenIcon.fadeIn(100);
            });
        }
    });

    mobileNavToggle.click(function(e){
        e.preventDefault();
        if(mobileInquireForm.is(':visible')){
            mobileInquireForm.animate({ height: 'toggle' }, 390, function() {
                toggleActiveClass(mobileInquireShowBtn, "active");
            });
        }
        var sideNavOverlay = $(mobileNavOverlayId);
        if (sideNavOverlay.length > 0) {
            mobileNavBtn.sideNav("hide");
        } else {
            mobileNavBtn.sideNav("show");
        }
    });

    mobileSearchInput.focusin(function(){
        mobileSearchIcon.animate({left: '8px'}, 100).fadeOut("slow");
        mobileCurrencySelector.fadeOut(100, function(){
            mobileSearchInputBtn.fadeIn(100);
        });
    });

    mobileSearchInput.focusout(function(){
        if($(this).val() == ""){
            mobileSearchIcon.animate({left: '27px'}, 100).fadeIn("slow");
            mobileSearchInputBtn.fadeOut(100, function(){
                mobileCurrencySelector.fadeIn(100);
            });
        }
    });

    mobileSearchBtn.click(function(){
        mobileSearchInput.focus();
    });

    mobileCurrencySelector.click(function(){
        if(mobileCurrencyArrow.hasClass('arrow-open')){
            mobileCurrencyArrow.removeClass('arrow-open');
            mobileCurrencyOptions.stop().slideUp(100);
        }
        else{
            mobileCurrencyArrow.addClass('arrow-open');
            mobileCurrencyOptions.stop().slideDown(100);
        }
    });

    mobileInquireHideBtn.click(function(){
        mobileInquireNow.removeClass(mobileInquireDisplayedClass).stop().animate({ bottom:'-100px' }, 250, function(){
            mobileInquireNow.addClass(mobileInquireHiddenClass);
        });
    });

    mobileInquireShowBtn.click(function(e){
        e.preventDefault();
        var iOSversion = yebalok.iPhoneVersion();
        if(iOSversion){
            console.log(iOSversion);
            window.location = $(".side-nav .contact-link").attr('href');
        }
        else{
            var sideNavOverlay = $(mobileNavOverlayId);
            if (sideNavOverlay.length > 0) {
                mobileNavBtn.sideNav("hide");
            }

            //block scrolling while inquire form is open.
            allowWindowScroll = false;

            mobileInquireForm.animate({ height: 'toggle' }, 390, function() {
                $('body').css('overflow', 'hidden');
                toggleActiveClass(mobileInquireShowBtn, "active");
            });
        }
    });

    mobileInquireFormClose.click(function(e){
        e.preventDefault();
        allowWindowScroll = true;
        mobileInquireForm.animate({ height: 'toggle' }, 390, function() {
            $('body').css('overflow', 'auto');
            toggleActiveClass(mobileInquireShowBtn, "active");
        });
    });

    navbarWindow.click(function(event){
        if(!$(event.target).hasClass('show-share-icons')){
            if(!$(event.target).hasClass('share-icon')){
                if(mobileShareTooltip.hasClass("share-icons-displayed")){
                    mobileShareTooltip.removeClass("share-icons-displayed").animate({height: 'toggle'}, 360, function(){});
                }
            }
        }
    });

    mobileShareToggle.click(function(event){
        event.preventDefault();
        toggleActiveClass(mobileShareTooltip, "share-icons-displayed");
        mobileShareTooltip.animate({height: 'toggle'}, 360, function(){});
    });

    /* ========== DESKTOP EVENTS =========== */

    desktopDropDown.dropdown();
    desktopDropDown.click(function(event){
        event.preventDefault();
    });

    desktopNavSearchBtn.click(function(e){
        e.preventDefault();
        desktopSearchIcon.fadeOut(100, function(){
            desktopSearchGoBackIcon.fadeIn(100);
        });
        desktopNavSearchContainer.animate({ width: "372px" }, 200, function(){
            desktopSearchInput.focus();
        });
    });
    
    window.onclick = function(event) {
        if(desktopNavSearchContainer.css('width') == '372px'){
            var input = document.getElementById('search-text-desktop'), button = document.getElementById('search-button-desktop');
            if( (event.target.id != input.id) && (event.target.id != button.id) ){
                desktopSearchGoBackIcon.fadeOut(100, function(){
                    desktopSearchIcon.fadeIn(100);
                    desktopNavSearchContainer.animate({ width: "0px" }, 200);
                });
            }
        }
    }

    desktopCurrencySelector.click(function(event){
        event.preventDefault();
    }).focusout(function(){
        desktopCurrencyList.fadeOut();
    });

    desktopCurrency.click(function(event){
        if(desktopCurrencyList.is(":visible")){
            desktopCurrencyList.fadeOut();
        }
        else{
            desktopCurrencyList.fadeIn();
        }
    });

    /* ========== ALL PLATFORM EVENTS =========== */
    navbarWindow.mousemove(function(event){
        navbarWindow.scroll();
    });

    navbarWindow.scroll(function(event){

        var viewTop = navbarWindow.scrollTop();

        if(viewTop >= 100 && !desktopNav.hasClass(navCompleteAnimationClass)){
            desktopNav.addClass(navCompleteAnimationClass);

            if(isScrolling){
                animateStop();
            }
            isScrolling = true;

            desktopTopNavItems.fadeOut(100);
            desktopTopNav.slideUp(100, function(){
                animateBackground(desktopNav, 100, false, function(){
                    desktopBrandLogo.fadeTo(100, 1);
                    animateTextColor(desktopNav, 100, false, function(){});
                });
            });

        }

        else if(viewTop < 100 && desktopNav.hasClass(navCompleteAnimationClass)){
            if(isScrolling){
                animateStop();
            }
            isScrolling = true;
            desktopNav.removeClass(navCompleteAnimationClass);

            animateTextColor(desktopNav, 100, true, function(){
                desktopBrandLogo.fadeTo("slow", 0);
                animateBackground(desktopNav, 100, true, function(){
                    desktopTopNav.slideDown(100, function(){
                        desktopTopNavItems.fadeIn(100);
                    });
                });
            });
        }

        checkMobileFixedStatus(mobileStickyNav, mobileInquireNow);

        if(mobileShareTooltip.hasClass("share-icons-displayed")){
            mobileShareTooltip.removeClass("share-icons-displayed").animate({height: 'toggle'}, 360, function(){});
        }

    });
});



// WEBPACK FOOTER //
// ./js/partials/navbar.js